import { FaUsers, FaBirthdayCake, FaGift, FaDove, FaGraduationCap, FaBaby, FaBookmark } from 'react-icons/fa';

export const TEMPLATE_ICONS = {
  reunion: FaUsers,
  birthday: FaBirthdayCake,
  holiday: FaGift,
  memorial: FaDove,
  graduation: FaGraduationCap,
  baby: FaBaby,
  saved: FaBookmark,
};

const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Due date = event date minus days_before, never earlier than today.
export function dueDateFor(startDate, daysBefore) {
  if (!startDate || daysBefore === null || daysBefore === undefined) return null;
  const [y, m, d] = startDate.slice(0, 10).split('-').map(Number);
  const due = new Date(y, m - 1, d - daysBefore);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return toIso(due < today ? today : due);
}

export function describeLeadTime(daysBefore) {
  if (daysBefore === null || daysBefore === undefined) return 'No due date';
  if (daysBefore === 0) return 'Day of event';
  if (daysBefore % 7 === 0) return `${daysBefore / 7} week${daysBefore === 7 ? '' : 's'} before`;
  return `${daysBefore} day${daysBefore === 1 ? '' : 's'} before`;
}

export function formatDue(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
